module.exports = "/_next/static/resources/box-b379b9ac71a86c4d9c97593e6f0cf46e.jpg";